import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';
import { Scope, SortOption } from '@utils/backend-api/search';

import SearchContent from './Content';

const queryClient = new QueryClient();

export interface SearchPageProps {
  env: Env;
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  isWebview: boolean;
  page: number;
  pageCount?: number;
  query?: string;
  scope: Scope;
  sort: SortOption;
}

const SearchPage = (props: SearchPageProps) => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <SearchContent {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default SearchPage;
